export const PROPERTY = '/property/:location/:slug';
